function Card({ children, className = '' }) {
    return (
        <div className={`rounded-2xl shadow-xl overflow-hidden bg-white ${className}`}>
            {children}
        </div>
    );
}

export default Card;